import { FormControl, MenuItem, Select } from "@mui/material";
import { useEffect, useState } from "react";

import Colors from "../../../../../../../../../../global/Colors";
import Title from "../../../../../components/Title";
import { STRINGS } from "../../../../components/utils/strings";
import { useProCliStore } from "../../../../hooks/useProCliStore";

export default function TransportationStatus({
  canEdit,
  title,
  index,
  fieldName,
  initialValue,
  updateProviderInfo,
}) {
  const { providersData } = useProCliStore();
  const [transportationValue, setTransportationValue] = useState(STRINGS.BOOLEAN_STATUS.NO);

  const isDisabled = !canEdit;

  const getBooleanValue = (value) => value === STRINGS.BOOLEAN_STATUS.YES;

  const handleChange = (event) => {
    const value = event.target.value;
    setTransportationValue(value);
    const boolValue = getBooleanValue(value);
    const existingFields = providersData.get(index).editableFields;
    let editableData = null;

    if (boolValue === initialValue) {
      if (existingFields && Object.keys(existingFields).length > 1) {
        editableData = { ...existingFields };
        delete editableData[fieldName];
      }

      const updatedData = new Map(providersData);
      updatedData.set(index, {
        ...updatedData.get(index),
        editableFields: editableData,
      });
      updateProviderInfo(updatedData);
      return;
    }

    editableData = {
      ...existingFields,
      [fieldName]: boolValue,
    };

    const updatedData = new Map(providersData);
    updatedData.set(index, {
      ...updatedData.get(index),
      editableFields: editableData,
    });
    updateProviderInfo(updatedData);
  };

  useEffect(() => {
    setTransportationValue(initialValue ? STRINGS.BOOLEAN_STATUS.YES : STRINGS.BOOLEAN_STATUS.NO);
  }, [initialValue]);

  return (
    <div className="w-full">
      <Title text={title} size={"text-xs"} horizontalPadding="pl-2" className="block w-full" />
      <FormControl sx={{ marginTop: "0.5rem", width: 160 }} size="small">
        <Select
          labelId={`Provider-Tab-${fieldName}-label`}
          id={`Provider-Tab-${fieldName}-select`}
          className="w-full"
          value={transportationValue}
          label={title}
          onChange={handleChange}
          sx={{
            "& legend": { display: "none" },
            "& fieldset": { top: 0 },
            "&.Mui-disabled": {
              backgroundColor: isDisabled ? Colors.gray[200] : Colors.white,
            },
            padding: "1px",
            fontSize: "0.85rem",
            borderRadius: "50px",
            backgroundColor: Colors.white,
          }}
          disabled={isDisabled}
        >
          <MenuItem value={STRINGS.BOOLEAN_STATUS.YES}>{STRINGS.BOOLEAN_STATUS.YES}</MenuItem>
          <MenuItem value={STRINGS.BOOLEAN_STATUS.NO}>{STRINGS.BOOLEAN_STATUS.NO}</MenuItem>
        </Select>
      </FormControl>
    </div>
  );
}
